import { CssBaseline } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from 'routing';
import { useTrackLogin } from 'shared/hooks';
import { useService } from 'shared/providers';
import { ICacheClear } from 'shared/types';
import { RegisterAppUpdate, gtag } from 'startup';

export default function App() {
  useTrackLogin();
  const localStorageName = 'insight.wps.cache-clear';
  const { pathname, search } = useLocation();
  const {
    appConfig: { googleTagId, enableGoogleAnalytics },
  } = useService();

  const hasClearedCacheRawValue = localStorage.getItem(localStorageName);
  const cacheClearValue: ICacheClear | null = hasClearedCacheRawValue ? JSON.parse(hasClearedCacheRawValue) : null;
  const hasClearedCache = cacheClearValue && cacheClearValue.hasClearedCache;
  useEffect(() => {
    if (!hasClearedCache) {
      localStorage.removeItem('insight.wps.freight-table-configurations');
      localStorage.removeItem('insight.wps.customer-commodity-table-configurations');
      localStorage.removeItem('insight.wps.product-table-configurations');

      localStorage.setItem(localStorageName, JSON.stringify({ hasClearedCache: true } as ICacheClear));
    }
  }, [hasClearedCache]);

  useEffect(() => {
    if (enableGoogleAnalytics) {
      gtag('config', googleTagId, {
        page_path: pathname + search,
      });
    }
  }, [pathname, search, enableGoogleAnalytics, googleTagId]);

  return (
    <>
      <CssBaseline />
      <RegisterAppUpdate />
      <AppRoutes />
    </>
  );
}
